import { render, staticRenderFns } from "./CrudView.vue?vue&type=template&id=42fefbb8&scoped=true&"
import script from "./CrudView.vue?vue&type=script&lang=js&"
export * from "./CrudView.vue?vue&type=script&lang=js&"
import style0 from "./CrudView.vue?vue&type=style&index=0&id=42fefbb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fefbb8",
  null
  
)

export default component.exports